import React from 'react'
import { Route } from 'react-router-dom'
import Survey from '../../../../components/SurveyView'

const SurveyRoutes = ({ match }) => (
  <>
    <Route path={match.path} component={Survey} />
  </>
)

export default SurveyRoutes
